/* eslint-disable no-unused-vars */

import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Tooltip
} from '@mui/material';
import React from 'react';

const PackageDetailsImageDialog = ({
  open,
  onClose,
  imageUrl,
  zoomLevel,
  onZoomIn,
  onZoomOut,
  onDownload
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogContent
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#000',
          p: 2
        }}
      >
        <img
          src={imageUrl}
          alt="Full size"
          style={{
            height: `${zoomLevel}px`,
            objectFit: 'contain',
            display: 'block',
            maxWidth: '100%'
          }}
        />
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: 'space-between',
          px: 3,
          pb: 2,
          backgroundColor: '#f4f4f4'
        }}
      >
        <Box>
          <Tooltip title="Zoom In">
            <IconButton onClick={onZoomIn}>
              <ZoomInIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Zoom Out">
            <IconButton onClick={onZoomOut}>
              <ZoomOutIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Download">
            <IconButton onClick={onDownload}>
              <DownloadIcon />
            </IconButton>
          </Tooltip>
        </Box>
        <Tooltip title="Close">
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </DialogActions>
    </Dialog>
  );
};

export default PackageDetailsImageDialog;
